<template>
  <div>
    <v-app-bar
      flat
      fixed
      app
      class="nav"
    >
      <v-icon
        style="padding: 2px"
        @click="toggleDrawer"
      >
        mdi-order-bool-descending
      </v-icon>

      <v-breadcrumbs
        divider=">"
        :items="$route.meta.breadcrumb"
      />

      <v-spacer />

      <v-btn
        icon
        small
        class="mr-4"
        @click="$vuetify.theme.dark = !$vuetify.theme.dark"
      >
        <v-icon>{{ $vuetify.theme.dark ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</v-icon>
      </v-btn>

      <v-menu
        bottom
        min-width="200px"
        rounded
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn
            text
            fab
            dark
            small
            class="mr-8"
            v-on="on"
          >
            <v-badge
              overlap
              color="orange"
            >
              <template v-slot:badge>
                {{ eventPagination.total }}
              </template>
              <v-icon
                large
                color="grey "
              >
                mdi-trash-can
              </v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-card>
          <v-card-text class="px-0">
            <v-list-item-content class="justify-center">
              <v-list
                two-line
                style="max-height: 750px"
                class="overflow-y-auto"
              >
                <v-list-item-group
                  active-class="pink--text"
                  multiple
                >
                  <template v-for="(item, index) in eventNotifications">
                    <v-list-item
                      :key="item.id"
                      @click="viewPage(item.id,'event')"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="item.data.name" />

                        <v-list-item-subtitle
                          class="text--primary"
                          v-text="item.data.text"
                        />

                        <v-list-item-subtitle v-text="item.data.thanks" />
                      </v-list-item-content>

                      <v-list-item-action-text>
                        <span class="primary-color">{{
                          moment(item.created_at).format("DD-MM-YY")
                        }}</span>
                      </v-list-item-action-text>
                    </v-list-item>

                    <v-divider
                      v-if="index < eventNotifications.length - 1"
                      :key="index"
                    />
                  </template>
                </v-list-item-group>
              </v-list>
              <v-divider />
              <v-list-item @click="viewEventNoti">
                <div class="mx-auto text-center">
                  <span class="primary-color">ອ່ານທັງໝົດ</span>
                </div>
              </v-list-item>
            </v-list-item-content>
          </v-card-text>
        </v-card>
      </v-menu>

      <v-menu
        bottom
        min-width="200px"
        rounded
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn
            text
            fab
            dark
            small
            class="mr-8"
            v-on="on"
          >
            <v-badge
              overlap
              color="orange"
            >
              <template v-slot:badge>
                {{ pagination.total }}
              </template>
              <v-icon
                large
                color="grey darken-1"
              >
                notifications
              </v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-card>
          <v-card-text class="px-0">
            <v-list-item-content class="justify-center">
              <v-list
                two-line
                style="max-height: 650px"
                class="overflow-y-auto"
              >
                <v-list-item-group
                  active-class="pink--text"
                  multiple
                >
                  <template v-for="(item, index) in notifications">
                    <v-list-item
                      :key="item.id"
                      @click="viewPage(item.id,'all')"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="item.data.name" />

                        <v-list-item-subtitle
                          class="text--primary"
                          v-text="item.data.text"
                        />

                        <v-list-item-subtitle v-text="item.data.thanks" />
                      </v-list-item-content>

                      <v-list-item-action-text>
                        <span class="primary-color">{{
                          moment(item.created_at).format("DD-MM-YY")
                        }}</span>
                      </v-list-item-action-text>
                    </v-list-item>

                    <v-divider
                      v-if="index < notifications.length - 1"
                      :key="index"
                    />
                  </template>
                </v-list-item-group>
              </v-list>
              <v-divider />
              <v-list-item @click="viewAllNoti">
                <div class="mx-auto text-center">
                  <span class="primary-color">ອ່ານທັງໝົດ</span>
                </div>
              </v-list-item>
            </v-list-item-content>
          </v-card-text>
        </v-card>
      </v-menu>

      <v-menu
        bottom
        min-width="200px"
        rounded
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            x-large
            v-on="on"
          >
            <v-avatar
              color="grey"
              size="46px"
            >
              <span class="white--text text-h5 text-break">{{ name }}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-card>
          <v-list-item-content class="justify-center">
            <div class="mx-auto text-center">
              <v-avatar
                color="grey"
                size="46px"
              >
                <span class="white--text text-h5 text-break">{{ name }}</span>
              </v-avatar>
              <h4>{{ userProfile.name }}</h4>
              <p class="text-caption mt-1">
                {{ userProfile.email }}
                <br>
              </p>
              <v-divider class="my-3" />
              <v-btn
                depressed
                rounded
                text
                @click="userLogout"
              >
                Log out
              </v-btn>
            </div>
          </v-list-item-content>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="miniVariant"
      :width="drawerWidth"
      mini-variant-width="64"
      fixed
      app
      floating
      class="app-navigation-menu"
    >
      <div class="vertical-nav-header d-flex items-center ps-6 pe-5 pt-5 pb-2">
        <router-link
          to="/"
          class="d-flex align-center text-decoration-none"
        >
          <v-img
            :src="require('../../assets/logo-finalized.png')"
            max-height="60px"
            max-width="60px"
            alt="logo"
            contain
            eager
            class="app-logo me-3"
          />
          <v-slide-x-transition>
            <h3
              v-if="!miniVariant"
              class="app-title text--primary"
            >
              Vientiane Waste
            </h3>
          </v-slide-x-transition>
        </router-link>
      </div>

      <v-list
        expand
        shaped
      >
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
          :to="item.to"
          router
          exact
          color="indigo darken-4"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-text="item.title" />
          </v-list-item-content>
        </v-list-item>
        <div
          v-for="{ item, newSection } in visibleGroups"
          :key="item.title"
          class="group-menu"
        >
          <v-subheader
            v-if="newSection && !miniVariant"
            class="menu-section"
          >
            {{ item.section }}
          </v-subheader>
          <v-divider
            v-else-if="newSection"
            class="my-1"
          />
          <v-list-group
            v-if="item.menu.length"
            class="group-menu-icon"
            :prepend-icon="item.icon"
            no-action
            color="indigo darken-4"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title> {{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <div
              v-for="(i, index) in item.menu"
              :key="index"
              style="padding-left: 22px"
            >
              <v-list-item
                v-if="allowed(i, i.permissions)"
                exact
                color="primary-color"
                :to="i.to"
              >
                <v-list-item-action>
                  <v-icon>{{ i.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title v-text="i.title" />
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-list-group>
          <v-list-item
            v-else
            :to="item.to"
            router
            exact
            color="indigo darken-4"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content style="padding-left: 20px">
              <v-list-item-title v-text="item.title" />
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
      <div
        v-if="!miniVariant"
        class="resize-handle"
        @mousedown.prevent="startResize"
      />
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import menus from '@/router/menus.js';

export default {
  data() {
    const savedWidth = parseInt(window.localStorage.getItem('sidebarWidth'), 10);
    const savedMini = window.localStorage.getItem('sidebarMini') === 'true';
    return {
      drawer: true,
      miniVariant: savedMini,
      drawerWidth: Number.isFinite(savedWidth) && savedWidth >= 200 && savedWidth <= 400 ? savedWidth : 260,
      minWidth: 200,
      maxWidth: 400,
      isResizing: false,
      resizeStartX: 0,
      resizeStartWidth: 0,
      userProfile: {},
      name: '',
      // Pagination
      offset: 12,
      pagination: {},
      eventPagination: {},
      per_page: 20,
      notifications: [],
      eventNotifications: [],
      selectedStatus: 'unread',
      items: [],
      group_menu: menus,
    };
  },

  computed: {
    user() {
      return this.$store.getters['User/getUsertype'];
    },
    profile() {
      return this.$store.getters['User/getUserProfile'];
    },
    ...mapGetters({
      userRole: 'User/getUserRole',
    }),
    /**
     * The groups this user may see, in menu order. newSection marks the first visible group of
     * a section, where its header goes: a section with nothing visible shows no header.
     */
    visibleGroups() {
      const visible = this.group_menu.filter((g) => this.allowed(g, g.menu.length ? g.group_permissions : g.permissions));
      return visible.map((item, i) => ({ item, newSection: i === 0 || item.section !== visible[i - 1].section }));
    },
  },
  created() {
    this.userProfile = JSON.parse(window.localStorage.getItem('user'));
    this.name = this.userProfile.name.slice(0, 1);
    this.fetchData();
    this.fetchEventData();
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onResize);
    document.removeEventListener('mouseup', this.stopResize);
  },
  methods: {
    ...mapActions({
      Logout: 'User/destroyToken',
    }),
    /** Not excluded by role, and has one of the permissions (none listed = open to all). */
    allowed(entry, permissions) {
      const roleOk = !entry.except_roles || (entry.except_roles.length && !this.$role(entry.except_roles));
      return Boolean(roleOk && (!permissions || !permissions.length || this.$can(permissions)));
    },
    toggleDrawer() {
      if (this.$vuetify.breakpoint.mobile) {
        this.drawer = !this.drawer;
      } else {
        this.miniVariant = !this.miniVariant;
        window.localStorage.setItem('sidebarMini', this.miniVariant);
      }
    },
    startResize(e) {
      this.isResizing = true;
      this.resizeStartX = e.clientX;
      this.resizeStartWidth = this.drawerWidth;
      document.addEventListener('mousemove', this.onResize);
      document.addEventListener('mouseup', this.stopResize);
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    },
    onResize(e) {
      if (!this.isResizing) return;
      const next = this.resizeStartWidth + (e.clientX - this.resizeStartX);
      this.drawerWidth = Math.max(this.minWidth, Math.min(this.maxWidth, next));
    },
    stopResize() {
      if (!this.isResizing) return;
      this.isResizing = false;
      document.removeEventListener('mousemove', this.onResize);
      document.removeEventListener('mouseup', this.stopResize);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
      window.localStorage.setItem('sidebarWidth', this.drawerWidth);
    },
    userLogout() {
      this.$store.dispatch('auth/destroyToken');
    },
    fetchData() {
      this.$store.commit('Loading_State', true);
      this.$axios
        .get('notification', {
          params: {
            page: this.pagination.current_page,
            per_page: this.per_page,
            status: this.selectedStatus,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.$store.commit('Loading_State', false);
              this.notifications = res.data.data.data;
              this.pagination = res.data.data.pagination;
            }, 300);
          }
        })
        .catch((error) => {
          this.$store.commit('Loading_State', false);
          this.$store.commit('Toast_State', {
            value: true,
            color: 'error',
            msg: error.response
              ? error.response.data.message
              : 'Something went wrong',
          });
        });
    },
    fetchEventData() {
      this.$store.commit('Loading_State', true);
      this.$axios
        .get('notification', {
          params: {
            page: this.eventPagination.current_page,
            per_page: this.per_page,
            status: this.selectedStatus,
            type: 'EVENT',
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.$store.commit('Loading_State', false);
              this.eventNotifications = res.data.data.data;
              this.eventPagination = res.data.data.pagination;
            }, 300);
          }
        })
        .catch((error) => {
          this.$store.commit('Loading_State', false);
          this.$store.commit('Toast_State', {
            value: true,
            color: 'error',
            msg: error.response
              ? error.response.data.message
              : 'Something went wrong',
          });
        });
    },
    viewAllNoti() {
      this.$router.push({
        name: 'NotificationTab',
      });
    },
    viewEventNoti() {
      this.$router.push({
        name: 'NotificationTab',
        query: { types: ['EVENT', 'CUSTOMER_EVENT'] },
      });
    },
    moveObjectToLast(array, id) {
      const index = array.findIndex((obj) => obj.id === id);
      if (index !== -1) {
        const objectToMove = array.splice(index, 1)[0];
        array.push(objectToMove);
      }
    },
    viewPage(id, type) {
      if (type == 'all') {
        this.pagination.total -= 1;
        this.moveObjectToLast(this.notifications, id);
      }
      if (type == 'event') {
        this.eventPagination.total -= 1,
        this.moveObjectToLast(this.eventNotifications, id);
      }
      this.$router.push({
        name: 'NotificationView',
        params: { id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../public/scss/main.scss";

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 20px !important;
}

.v-application--is-ltr .v-list-item__action[data-v-117f5fe7]:first-child,
.v-application--is-ltr .v-list-item__icon[data-v-117f5fe7]:first-child {
  margin-right: 8px !important;
}

.menu-section.v-subheader {
  height: 32px;
  margin-top: 8px;
  padding-left: 20px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.3px;
  color: #5c6bc0 !important;
}

.group-menu,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 8px !important;
}

.v-application--is-ltr
.v-list-group--no-action
> .v-list-group__items
> .v-list-item {
  padding-left: 30px !important;
}

.nav {
  border-bottom: 1px solid #eee;
  background: #fff !important;
}

.theme--dark .nav {
  border-bottom: 1px solid #333;
  background: #1E1E1E !important;
}

.theme--light.v-navigation-drawer {
  border-right: 1px solid #eee !important;
}

.theme--dark.v-navigation-drawer {
  border-right: 1px solid #333 !important;
}

.theme--light .v-main__wrap.v-main__wrap {
  background: #eee !important;
}

.theme--dark .v-main__wrap.v-main__wrap {
  background: #121212 !important;
}

.theme--dark .v-list-item--active {
  background-color: rgba(73, 163, 218, 0.2) !important;
  color: #49A3DA !important;
}

.theme--dark .v-list-item--active .v-list-item__title,
.theme--dark .v-list-item--active .v-icon {
  color: #49A3DA !important;
}

.theme--dark .v-list-group--active > .v-list-group__header {
  background-color: rgba(73, 163, 218, 0.2) !important;
}

.theme--dark .v-list-group--active > .v-list-group__header .v-list-item__title,
.theme--dark .v-list-group--active > .v-list-group__header .v-icon {
  color: #49A3DA !important;
}

.resize-handle {
  position: absolute;
  top: 0;
  right: 0;
  width: 5px;
  height: 100%;
  cursor: col-resize;
  background: transparent;
  z-index: 10;
  transition: background 0.15s ease;
}

.resize-handle:hover,
.resize-handle:active {
  background: rgba(73, 163, 218, 0.4);
}
</style>
